import React from 'react';
import { Phone, TrendingUp, Scale, CreditCard } from 'lucide-react';

const FeatureCards = () => {
    const features = [
        {
            id: 1,
            icon: <Phone size={40} />,
            iconBg: '#0d203a',
            title: 'سهولة التواصل',
            description: 'سمارت ترند بتوفرلك طرق تواصل متعدده طوال اليوم '
        },
        {
            id: 2,
            icon: <TrendingUp size={40} />,
            iconBg: '#0d203a',
            title: 'خصومات تصل إلي 50%',
            description: 'سمارت ترند بتوفرلك اعلى نسبة خصم على جميع الخدمات التحاليل الطبية و الاشعة التشخيصية لدى اشهر مقدمى الخدمات'
        },
        {
            id: 4,
            icon: <CreditCard size={40} />,
            iconBg: '#0d203a',
            title: 'طرق دفع متعددة و آمنة ',
            description: 'هتقدر تدفع اسعار الخدمات باكثر من طريقة زى الفيزا والمحفظة الذكية او عن طريق فورى'
        }
    ];

    return (
        <div style={{
            backgroundColor: 'white',
            padding: '80px 20px',
            fontFamily: 'Cairo, Arial, sans-serif',
            direction: 'rtl'
        }}>
            <div className="container">
                {/* Section Header */}
                <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                    <h2 style={{
                        color: '#0d203a',
                        fontSize: '2.5rem',
                        fontWeight: 'bold',
                        marginBottom: '15px',
                        position: 'relative',
                        display: 'inline-block'
                    }}>
                        مميزات المنصة
                        <span style={{
                            position: 'absolute',
                            bottom: '-10px',
                            right: '50%',
                            transform: 'translateX(50%)',
                            width: '100px',
                            height: '4px',
                            backgroundColor: '#0d203a',
                            borderRadius: '2px'
                        }}></span>
                    </h2>
                    <p style={{
                        color: '#6c757d',
                        fontSize: '1.1rem',
                        marginTop: '20px'
                    }}>
                        توفر المنصة خدمات التحاليل الطبية و الأشعة التشخيصية لدى اشهر مقدمى الخدمات بخصومات عالية و طرق دفع متعدده و آمنة
                    </p>
                </div>

                {/* Features Grid */}
                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div key={feature.id} className="col-md-6 col-lg-4 ">
                            <div
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    padding: '40px 25px',
                                    textAlign: 'center',
                                    boxShadow: '0 10px 30px rgba(13, 32, 58, 0.08)',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    cursor: 'pointer',
                                    border: '2px solid transparent',
                                    height: '100%',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    animationDelay: `${index * 0.1}s`
                                }}
                                className="feature-card"
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-15px)';
                                    e.currentTarget.style.boxShadow = '0 20px 50px rgba(74, 222, 128, 0.25)';
                                    e.currentTarget.style.borderColor = '#0d203a';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(13, 32, 58, 0.08)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}
                            >
                                {/* Background Pattern */}
                                <div style={{
                                    position: 'absolute',
                                    top: '-50px',
                                    left: '-50px',
                                    width: '150px',
                                    height: '150px',
                                    backgroundColor: feature.iconBg,
                                    borderRadius: '50%',
                                    opacity: '0.05',
                                    transition: 'all 0.4s ease'
                                }}></div>

                                {/* Icon Container */}
                                <div style={{
                                    width: '90px',
                                    height: '90px',
                                    margin: '0 auto 25px',
                                    backgroundColor: `${feature.iconBg}15`,
                                    borderRadius: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                    transition: 'all 0.4s ease'
                                }}
                                    className="icon-container">
                                    <div style={{ color: feature.iconBg }}>
                                        {feature.icon}
                                    </div>
                                </div>

                                {/* Title */}
                                <h3 style={{
                                    color: '#0d203a',
                                    fontSize: '1.4rem',
                                    fontWeight: 'bold',
                                    marginBottom: '15px',
                                    transition: 'color 0.3s ease'
                                }}>
                                    {feature.title}
                                </h3>

                                {/* Description */}
                                <p style={{
                                    color: '#6c757d',
                                    fontSize: '1rem',
                                    lineHeight: '1.8',
                                    margin: 0
                                }}>
                                    {feature.description}
                                </p>

                                {/* Bottom Accent Line */}
                                <div style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    left: 0,
                                    height: '4px',
                                    backgroundColor: feature.iconBg,
                                    transform: 'scaleX(0)',
                                    transformOrigin: 'right',
                                    transition: 'transform 0.4s ease'
                                }}
                                    className="accent-line"></div>
                            </div>
                        </div>
                    ))}
                </div>


            </div>

            <style>
                {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .feature-card {
            animation: fadeInUp 0.6s ease forwards;
            opacity: 0;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1) rotate(5deg);
          }

          .feature-card:hover .accent-line {
            transform: scaleX(1);
          }

          @media (max-width: 768px) {
            .feature-card {
              margin-bottom: 20px;
            }
          }
        `}
            </style>
        </div>
    );
};

export default FeatureCards;